import { render, staticRenderFns } from "./GitlabProjectSelect.vue?vue&type=template&id=2f159010&scoped=true"
import script from "./GitlabProjectSelect.vue?vue&type=script&lang=js"
export * from "./GitlabProjectSelect.vue?vue&type=script&lang=js"
import style0 from "./GitlabProjectSelect.vue?vue&type=style&index=0&id=2f159010&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f159010",
  null
  
)

export default component.exports